<template>
  <div class="footer">
    <p class="footer-text">#The F2E 3rd Week01 <span> 台灣走走 © Code: Eva / Design: Breakfast </span></p>
    
  </div>
</template>
<style lang="scss" scoped>
@import "~@/assets/all.scss";
.footer {
  margin-top: 4rem;
  background-color: #65895f;
  line-height: 60px;
}
.footer-text {
  font-size: 14px;
  color: #fff;
  margin-bottom: 0px;
}
</style>
